import React from 'react'
import VisibleComponent from '../../shared/VisibleComponent'

const MentionsLegales = () => {
  return (
    <div className="content">
      <VisibleComponent>
        <div className="elements-group">
          <h2>Mentions légales</h2>
          <h3>Propriété du site/Éditeur</h3>
          <p>
            Ce site internet, ayant un but informatif, est la propriété de
            l’association : Les Brayauds-CDMDT63 40 rue de la République 63200
            Saint-Bonnet près Riom Téléphone : (+33) 04 73 63 36 75 mail :
            brayauds@wanadoo.fr
          </p>
          <h3>Directeur de publication</h3>
          <p>Raphaël Maurel – Président de l’association</p>
          <h3>Hébergement</h3>
          <p>
            SARL alwaysdata son adresse
            <br />
            91 Rue du Faubourg Saint-Honoré, 75008 Paris
            <br />
            +33 1 84 16 23 49
          </p>
          <h3>Droit de reproduction et droit d’auteur</h3>
          <p>
            Ce site relève de la législation française et internationale sur le
            droit d’auteur et la propriété intellectuelle. Tous les droits de
            reproduction sont réservés, y compris pour les documents
            téléchargeables et les représentations iconographiques et
            photographiques. En application de la loi du 11 mars 1957 (art. 41)
            et du code de la propriété intellectuelle du 1er juillet 1992 :
            l’ensemble des textes, illustrations, photographies, plans, dessins,
            animations, vidéos, sons contenus sur ce site internet ne peuvent
            pas être utilisés ou reproduits sans obtention de l’autorisation de
            l’éditeur.
          </p>
          <h3>Création d’un lien hypertexte </h3>
          <p>
            Si vous souhaitez créer un lien vers le site internet des Brayauds –
            Cdmdt63, adressez-vous au webmaster. L’éditeur se réserve le droit
            de demander la suppression d’un lien qu’il estime non conforme à sa
            ligne éditoriale.
          </p>
          <h3>Confidentialité</h3>
          <p>
            Conformément à la loi du 6 janvier 1978 relative à l’informatique,
            aux fichiers et aux libertés, vous disposez d’un droit d’accès, de
            modification, de rectification et de suppression des données qui
            vous concernent. Pour l’exercer, envoyer un message au webmaster.
            Nous ne collectons aucune donnée personnelle lors de votre visite du
            site.
          </p>
          <h3>Mise en garde</h3>
          <p>
            Les informations fournies sont non contractuelles, peuvent contenir
            des inexactitudes techniques ou typographiques et sont sujettes à
            modification sans préavis. Les Brayauds-CDMDT63 ne saurait être tenu
            pour responsable des erreurs, d’une absence de disponibilités des
            informations, exactitudes, mises à jour, de la présence d’un virus
            sur son portail Internet et des dommages quelconques, directs ou
            indirects, matériels ou immatériels résultant notamment de la
            consultation et/ou de l’utilisation de ce site web (ou d’autres
            sites qui lui sont liés) et des éventuelles applications en
            téléchargement. Les utilisateurs du site ont la possibilité
            d’informer le webmaster du site de toute omission ou erreur.
          </p>
        </div>
      </VisibleComponent>
    </div>
  )
}

export default MentionsLegales
